export default __webpack_public_path__ + "static/media/lupins.245c6a88.svg";